<template>
    <aside class="menu pt-5 user-menu">
        <div v-if="$route.name=='dashboard-user' ||  $route.name=='dashboard-user-plan'">
            <p
                class="is-size-4 pl-5 pt-5 pb-3 pr-6 mr-5 has-text-eduloc-red is-uppercase"
            >
                {{ $t('profile_title') }}
            </p>
            <ul class="menu-list">
                <li class="mx-4">
                    <router-link
                        v-t="'profile_data'"
                        :to="{
                            name: 'dashboard-user',
                        }"
                        exact
                        class=""
                    />
                </li>
                
                <!--<li class="mx-4"><div>
                    <router-link
                       
                        :to="{
                            name: 'dashboard-user-plan',
                        }"
                        exact
                        class=""
                    >{{ $t('profile_plan') }}
                        <img
                            v-if="showBadge"
                            src="@/assets/images/alerta_sol.svg"
                            alt="alerta"
                            class="info-badge"
                        />
                    </router-link>
                    </div>
                </li>-->
            </ul>
        </div>
        <div v-else>
            <p
                class="is-size-4 pl-5 pt-5 pb-3 pr-6 mr-5 has-text-eduloc-red is-uppercase"
            >
                {{ $t('Dashboard.projects') }}
            </p>
            <ul class="menu-list">
                <li class="mx-4">
                    <router-link
                        v-t="'Dashboard.mine'"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'mine',
                                search: this.$route.query.search,
                            },
                        }"
                        exact
                        class=""
                        :class="{ 'is-active': $route.query.filter == 'mine' }"
                    />
                </li>
                <li
                    v-for="folder in folders"
                    :key="folder._id"
                    class="mx-4"
                    :class="{ 'is-active': $route.query.folder == folder._id }"
                >
                    <router-link
                        class="py-1 pl-5"
                        :to="{ name: 'dashboard-folder', params: { folder: folder._id } }"
                        exact
                    >
                    <span class="icon-text mr-2">
                        <span class="icon pt-0">
                            <i class="mdi mdi-18px mdi-folder-outline"></i>
                        </span>
                    </span>
                    <span class="pt-1">{{ folder.name }}</span>
                    </router-link>
                </li>
                <li class="mx-4">
                    <router-link
                        v-t="'Dashboard.other_users'"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'invited',
                                search: this.$route.query.search,
                            },
                        }"
                        exact
                        class=""
                    />
                </li>
            <!-- <li v-if="hasSchool" class="mx-4">
                    <router-link
                        v-t="schoolName"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'mySchool',
                            },
                        }"
                        exact
                    />
                </li>-->
                <li class="mx-4" v-if="isAdmin">
                    <router-link
                        v-t="'Dashboard.all'"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'all',
                                search: this.$route.query.search,
                            },
                        }"
                        exact
                        class=""
                    />
                </li>
            
                <li class="mx-4" v-if="isAdmin">
                    <router-link
                        v-t="'Dashboard.import_content'"
                        :to="{ name: 'import' }"
                        exact
                    ></router-link>
                </li>

                <li class="mx-4" v-if="haveAppPage">
                    <router-link
                        v-t="'user_app_space'"
                        :to="{ name: 'userAppContent' }"
                        exact
                    />
                </li>
        
            </ul>
        </div>
        <!--<p
            class="is-size-4 pl-5 pt-5 pb-3 pr-6 mr-5 has-text-eduloc-red is-uppercase" v-if="isCoordinator"
        >
            {{ schoolName }}
        </p>
        <ul class="menu-list" v-if="isCoordinator">
            <li class="mx-4">
                <router-link
                    v-t="'Dashboard.users'"
                    :to="{ name: 'users' }"
                    exact
                    tag="a"
                />
            </li>
            <li class="mx-4">
                <router-link
                    v-t="'school_app_content'"
                    :to="{ name: 'appContent' }"
                    exact
                    tag="a"
                />
            </li>
        </ul>-->

       <!-- <div class="plan-info" style="position: absolute; bottom: 2.5rem;">
        <p class="is-size-6 pl-5 pt-5  pr-6 mr-5">
            {{ $t('license_type') }}: <span class="has-text-eduloc-red">{{ licenseType }}</span>
        </p>
        <p class="is-size-6 pl-5  pr-6 mr-5">
            {{ $t('projects') }}: <span class="has-text-eduloc-red">{{ $store.getters.projectsNumber }} / {{ maxProjects }}</span>
        </p>
        <p class="is-size-6 pl-5  pr-6 mr-5">
            {{ $t('objects') }}: <span class="has-text-eduloc-red">{{ $store.getters.objectsNumber }} / {{ maxObjects }}</span>
        </p>
        <p class="is-size-6 pl-5  pr-6 mr-5" v-if="hasSchool">
            {{ $t('users') }}: <span class="has-text-eduloc-red">{{ $store.getters.usersNumber }} / {{ maxUsers }}</span>
        </p>
    </div>-->
    </aside>
</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import moment from 'moment';
export default {
    props: {
        folders: { type: Array, default: () => [] },
    },
    data() {
        return {
            dropdownActive: false,
            dropdownText: 'mine',
            menuActive: 'projects',
            activeSelection: 'mine',
        };
    },
    mounted() {
        const collapsibles = bulmaCollapsible.attach();
        // console.log(this.$route.name)
        // console.log(this.$store.getters.userPlan)
        // console.log(this.competencies);
    },
    computed: {
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
        schoolName() {
            return this.$store.getters.school.name;
        },
        isCoordinator() {
            return this.$store.getters.hasSchool && this.$store.getters.canManageSchool;
        },
        /*hasCommunities() {
            return this.$store.getters.hasCommunities;
        },*/
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        licenseType() {
            if (this.isAdmin) {
                return this.$t('admin_license');
            } else if (this.hasSchool) {
                return this.$t('school_license');
            } else {
                return this.$t('individual_license');
            }
        },
        maxProjects() {
            if (this.$store.getters.activePlan) {
                // console.log(this.$store.getters.projectsNumber +"/"+ this.$store.getters.activePlan.configuration.project.maxNumber)
                if (this.$store.getters.activePlan.configuration.project.maxNumber === -1) {
                    return this.$t('unlimited_projects');
                } else {
                    return this.$store.getters.activePlan.configuration.project.maxNumber;
                }
            }
        },
        maxObjects() {
            if (this.$store.getters.activePlan) {
                // console.log(this.$store.getters.projectsNumber +"/"+ this.$store.getters.activePlan.configuration.object.maxNumber)
                if (this.$store.getters.activePlan.configuration.object.maxNumber === -1) {
                    return this.$t('unlimited_projects');
                } else {
                    return this.$store.getters.activePlan.configuration.object.maxNumber;
                }
            }
        },
        maxUsers() {
            if (this.$store.getters.activePlan) {
                // console.log(this.$store.getters.projectsNumber +"/"+ this.$store.getters.activePlan.configuration.object.maxNumber)
                if (this.$store.getters.activePlan.configuration.user.maxNumber === -1) {
                    return this.$t('unlimited_projects');
                } else {
                    return this.$store.getters.activePlan.configuration.user.maxNumber;
                }
            }
        },
        haveAppPage() {
            // console.log("have app page",this.$store.getters.activePlan)
            if (this.$store.getters.activePlan) { 
                if (this.$store.getters.activePlan.configuration.general) {
                    return this.$store.getters.activePlan.configuration.general.appPage;
                }
            } 
            return false;
        },
        activePlan() {
            return this.$store.getters.activePlan;
        },
        showBadge() {
            // console.log("active plan",this.hasSchool,this.activePlan)
            if (this.hasSchool && this.activePlan.configuration.general.endDate) {
                const data2 = moment(this.activePlan.configuration.general.endDate,"DD-MM-YYYY");
                const data1 = moment();
                const daysDiff=data2.diff(data1, 'days');
                if (data1.isBefore(data2) && daysDiff <= 5) {
                    return true
                }
            }
            return false;
        },
    },
    methods: {
        /*toggleMenu() {
            this.dropdownActive = !this.dropdownActive;
        },*/
        setMenuActive(element) {
            if (this.menuActive == element) {
                this.menuActive = '';
            } else {
                this.menuActive = element;
            }
        },
    },
};
</script>

<style scooped>
    aside.user-menu{
        height: calc(100vh - 5.2rem);
    }
    .notification-badge{
        background-color: var(--eduloc-yellow);
        top: 15px;
        height: 10px;
        padding: 0;
        min-width: 10px;
        border-radius: 10px;
        box-shadow: none;
        right: 6px;
    }
    .info-badge{
        height: 1.2rem;
        margin-left: 0.5rem;
        
        float: right;
    }
</style>


